<template>
	<div class="siting">
	<!-- tit -->
	<div class="main-icon">
		<div class="main-icon-a">
			<i :class="iconComes" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
			<span style="font-size: 14px;font-weight:bold;margin-left: 12px;color: #606266;display: inline-block;width: 88px;">{{ CatalogueName }}</span>
		</div>
		<!-- btn1 -->
		<div class="main-icon-zzgl">
			<span style="font-size: 14px;color: #606266;font-weight: bold;">有效状态：</span>
			<el-dropdown @command="handleCommand" trigger="click">
				<span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
				<el-dropdown-menu slot="dropdown">
				  <el-dropdown-item command="a">可用</el-dropdown-item>
				  <el-dropdown-item command="b">禁用</el-dropdown-item>
				  <el-dropdown-item command="c" divided>全部</el-dropdown-item>
				</el-dropdown-menu>
		    </el-dropdown>
		</div>
		<!-- btn2 -->
		<div class="main-icon-c">
			<span style="font-size: 14px;color: #606266;font-weight: bold;display: inline-block;width: 48px;">科室：</span>
			<el-select v-model="selectedValue" filterable placeholder="请选择" size="mini">
			    <el-option
			      v-for="item in options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<!-- 诊室 -->
			<span style="font-size: 14px;color: #606266;font-weight: bold;display: inline-block;width: 48px;margin-left: 20px;">诊室：</span>
			<el-select v-model="selectedValue" filterable placeholder="请选择" size="mini">
			    <el-option
			      v-for="item in options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<!-- 医生 -->
			<span style="font-size: 14px;color: #606266;font-weight: bold;display: inline-block;width: 48px;margin-left: 20px;">医生：</span>
			<el-select v-model="selectedValue" filterable placeholder="请选择" size="mini">
			    <el-option
			      v-for="item in options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
		</div>
		<!-- btn3 -->
		<div class="main-icon-c">
			<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini" plain @click="handClick(i)">{{ v.title }}</el-button>
		</div>
	</div>
	<!-- table -->
	<div class="table" ref="mainRight">
		<el-table :data="tableData" border @row-dblclick="handledbRow" :style="{ width: windowWidth + 'px' }">
			<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
			<!-- fixed -->
			<el-table-column fixed="left" label="行号" type="index" width="68" align="center"></el-table-column>
			<!-- edit -->
			<el-table-column fixed="right" label="操作" width="148">
			      <template slot-scope="scope">
					  <div class="editbox" style="text-align: center;">
						<el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
						<el-button type="danger" @click="handleDelete(scope.row.id)" size="mini">删除</el-button>
					  </div>
			      </template>
			</el-table-column>
		</el-table>
	</div>
	<!-- 分页 -->
	<el-pagination
	@size-change="handleSizeChange"
	@current-change="handleCurrentChange"
	:current-page="pageNum"
	:page-sizes="[5, 10, 20]"
	:page-size="pageSize"
	:total="totalSize"
	layout="total, sizes, prev, pager, next, jumper"
	background
	>
	</el-pagination>
	<!-- feet -->
	<div class="feet">
		<el-button v-for="(v,i) in feetBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="small" plain @click="feetHandClick(i)">{{ v.title }}</el-button>
	</div>
	<!-- add dialog -->
	<div class="addDiglog">
		<el-dialog title="新增" :visible.sync="dialogVisible" width="48%" :before-close="handleClose">
			<addDiglog></addDiglog>
		</el-dialog>
	</div>
	</div>
</template>

<script>
	// selfs / js
	import addDiglog from "./SitingAddDiglog.vue";
	export default{
		components:{
			addDiglog
		},
		data(){
			return{
				// str
				iconComes:'el-icon-zzgl',
				CatalogueName:'坐诊管理',
				DropDownedName:'可用',
				selectedValue:'',
				windowWidth: '',
				// blean
				loading:false,
				dialogVisible:false,
				// number
				pageNum: 1, //当前页currentPage
				pageSize: 8,
				totalSize: 10, //总条数
				// arr title右侧按钮
				headerBtn:[
				 { refesh:"refesh", title:"刷新", type:"primary", icon:"el-icon-refresh" },
				 { senior:"senior", title:"高级", type:"primary", icon:"" }],
				feetBtn:[
				 { refesh:"refesh", title:"新增", type:"primary", icon:"el-icon-plus" },
				 // { senior:"senior", title:"修改", type:"primary", icon:"el-icon-edit" },
				 // { refesh:"refesh", title:"删除", type:"primary", icon:"el-icon-minus" },
				 { refesh:"refesh", title:"医生设置", type:"primary", icon:"el-icon-zzgl" },
				 { refesh:"refesh", title:"打印", type:"primary", icon:"el-icon-ggml" },
				 { refesh:"refesh", title:"导出", type:"primary", icon:"el-icon-lcyt" },
				 ],
				options:[{value: '选项1',label: '黄金糕'},{value: '选项2',label: '双皮奶'}],
				tableRows:[
					{ name:"系统序号", prop:"code", nz:"nz" },{ name:"诊室名称", prop:"label", type:"" },{ name:"科室名称", prop:"healthID", type:"" },
					{ name:"医生名称", prop:"status", type:""},{ name:"挂号类别", prop:"IdCard", type:"" },{ name:"操作人", prop:"operator", type:"" },
					{ name:"操作时间", prop:"operatingTime", nz:"nz" },{ name:"开始时间", prop:"operatingTime", type:"" },{ name:"结束时间", prop:"operatingTime", type:"" },
					{ name:"上午开始时间", prop:"tel", type:"" },{ name:"上午结束时间", prop:"address", type:"" },{ name:"下午开始时间", prop:"operatingTime", type:"" },
					{ name:"下午结束时间", prop:"pType", type:"" },{ name:"晚班开始时间", prop:"operater", type:"" },{ name:"操作时间", prop:"operatingTime", type:"" },
					{ name:"院区", prop:"address", type:"" }
				],
				tableData: [
					{ num:'1', code:'1', label: '普通药', status: '可用', nz: '否',operatingTime:'2024-12-05 14：36：48',operator:'超级管理员',remark:'无关风月，我提序等你回。' },
					{ num:'2', code:'6', label: '指定药', status: '可用', nz: '否',operatingTime:'2024-12-06 16：42：03',operator:'超级管理员',remark:'悬笔一绝，那岸边浪千叠。' },
					{ num:'3', code:'7', label: '易制毒', status: '可用', nz: '否',operatingTime:'2024-12-06 23：36：28',operator:'超级管理员',remark:'情字何解，怎落笔都不对。' },	
				],
			}
		},
		mounted() {
			//获取动态盒子宽度，实时赋值给右侧 => this.$refs.mainRight.offsetWidth;
			this.$nextTick(()=>{
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			})
		},
		methods:{
			// headers commond
			handleCommand(command) {
			  // console.log(command);
			  // 根据 command 值执行相应的逻辑
			  switch (command) {
				case 'a':
				  // 处理a的逻辑
				  console.log('执行A逻辑');
				  this.DropDownedName = '可用'
				  break;
				case 'b':
				  // 处理b的逻辑
				  console.log('执行B逻辑');
				  this.DropDownedName = '禁用'
				  break;
				case 'c':
				  // 处理b的逻辑
				  this.DropDownedName = '全部'
				  break;
				// ... 其他 case
			  }
			},
			// 步骤
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// 处理索引0的逻辑
						this.loading = true;
						if(this.selectedValue == ''){
							setTimeout(() => {
								this.$message.error('未知错误,请稍后重试！');
								this.loading = false;		
							}, 1500)
						}else{
							this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						}
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
					case 2:
						// 处理索引2的逻辑 => 新增
						this.addDialogVisible = true
						break;
				}
			},
			feetHandClick(i){
				// i event
				switch (i) {
					case 0:
					// 处理索引1的逻辑
					this.dialogVisible = true;
					break;
					case 1:
					// 处理索引1的逻辑
					this.$confirm('敬请期待')
					.then(_ => {})
					.catch(_ => {});
					break;
					case 2:
					// 处理索引2的逻辑 => 新增
					this.$confirm('敬请期待')
					.then(_ => {})
					.catch(_ => {});
					break;
					case 3:
					// 处理索引3的逻辑 => 新增
					this.$confirm('敬请期待')
					.then(_ => {})
					.catch(_ => {});
					break;
				}
			},
			// db events
			handledbRow(row, column, event){
				if(row){ this.form = row; this.dialogVisible = true } else { console.log('fail'); }
				// console.log(this.form);
				this.formdisabled = true
				this.form.textSpell = this.makePy(this.form.label).toLocaleUpperCase()
				// console.log(this.form.textSpell);
			},
			// col 里面包含了表头字段和名称，list 是表格数据
			    columnWidth(col, list) {
			      let prop = col.prop,lab = col.lab;
			      let width = 40; // 设定一个最小值
			      let maxlenStr = ""; // 最长字符串
			      for (let info of list) {
			        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
			      }
			      width = Math.max(width, len(lab), len(maxlenStr));
			      // 表格自带的内边距(20px) 自调
			      return width + 24; // 这里加了 12px
			      function len(str) {
			        // 实际分配长度可根据需要自行调整
			        let length = 12;
			        for (const char of str + "") {
			          // 英文小写字符 8px
			          if ("a" <= char && char <= "z") length += 8;
			          // 英文大写字符 8px
			          else if ("A" <= char && char <= "Z") length += 8;
			          // 中文字符 28px
			          else if (char >= "\u4e00" && char <= "\u9fa5") length += 28;
			          // 其他 8px
			          else length += 12;
			        }
			        return length;
			  }
			},
			// addDiglog Close
			handleClose(done) {
				this.$confirm('确认关闭？')
				  .then(_ => {
					done();
				  })
				  .catch(_ => {
				  });
			},
			//分页
			//每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
			},
			// 实时宽度
			updateWindowWidth() {
			    this.windowWidth = window.innerWidth - 188;
			},
			
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .el-dropdown{
		font-size: 14px;
		cursor: pointer;
	}
	/deep/ .el-dropdown:hover {
		font-weight: bold;
		color: #66b1ff;
	}
	/deep/ .el-icon--right{
		// background-color: #66b1ff;
	}
	/deep/ .el-popper[x-placement^=bottom]{
		margin-top: 0;
	}
	/deep/ .el-dialog__header{
		padding: 12px;
		background-color: #007bb0;
	}
	
	/deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
		margin-bottom: 8px;
	}
	/deep/ .el-dialog__title{
		font-size: 12px;
		color: #fff;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close{
		color: #fff;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
		background-color: brown;
	}
	.siting{
		
		.main-icon{
			display: flex;
			align-items: center;
			padding: 12px;
			line-height: 40px;
			.main-icon-a{
				// width: 240px;
				// background-color: #00557f;
			}
			.main-icon-b{
				margin-left: 28px;
			}
			// c
			.main-icon-c{
				display: flex;
				margin-left: 28px;
				/deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b]{
					width: 80%;
				}
			}
		}
		.feet{
			display: flex;
			justify-content: center;
		}
	}
</style>